export const orderActions = {
  refundAndRestock: 'refund_and_restock',
  refundOnly: 'refund_only',
  restockOnly: 'restock_only',
  fulfilledToUnfulfilled: 'fulfilled_to_unfulfilled',
  restockedToUnfulfilled: 'restocked_to_unfulfilled',
  fulfilledToRestocked: 'fulfilled_to_restocked',
  unfulfilledToFulfilled: 'unfulfilled_to_fulfilled',
  readyToFulfillToUnFulfilled: 'ready_to_fulfill_to_unfulfilled',
  readyToFulfillToFulfilled: 'ready_to_fulfill_to_fulfilled',
}
